module.exports = __webpack_public_path__ + "static/img/map.a942b17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/map.png
// module id = NRL7
// module chunks = 1